import { Navigate } from "react-router-dom";
import { useMe } from "./queries";

export function RequireRole({
  roles,
  children,
}: {
  roles: readonly string[];
  children: React.ReactNode;
}) {
  const { data: user, isPending } = useMe();
  if (isPending) return <div className="p-8">Loading…</div>;
  if (user && user.role && roles.includes(user.role)) return <>{children}</>;
  return <Navigate to="/dashboard" replace />;
}
